import { create } from 'zustand';
import { HiveSiteSimpleDto } from '@pimm/services/lib/sms-tenants';

export const useSimpleSite = create<{
  site?: HiveSiteSimpleDto;
  setSite: (_store: HiveSiteSimpleDto) => void;
  clear: () => void;
}>(set => ({
  setSite: site => set({ site }),
  clear: () => set({ site: undefined }),
}));
